import React from "react";

import "react-datetime/css/react-datetime.css";
import CustomScroll from "react-custom-scroll";

export const BreachInfo = ({ _, openNewForm, formValues }) => {
  const {
    dateOfBreach,
    dateOfDiscovery,
    breachReporterName,
    reporterContactNo,
    reporterEmail,
    incidentOwnerName,
    incidentOwnerContactNo,
    incidentOwnerEmail,
    breachTypeText,
    locationAffected,
    descriptionOfBreach,
    affectedSubjects,
    descriptionOfActionTakenSinceDiscovery,
  } = formValues;

  return (
    <>
      <CustomScroll
        heightRelativeToParent={"calc(100% - 100px)"}
        allowOuterScroll={true}
      >
        <div className="ml-3 mb-5  d-flex report-sent-message">
          <i className="icon-omni-checkbox-true mr-2"></i>
          <h6>
            Thank you for reporting this breach. The below report has been sent.
          </h6>
        </div>
        <div>
          <div className="d-flex flex-wrap ml-3 report-breach-info">
            <div className="d-flex flex-wrap row report-details-1">
              <div className="col-4">
                <h6>Date of Breach</h6>
                <p>{dateOfBreach}</p>
              </div>
              <div className="col-4">
                <h6>Date of Discovery</h6>
                <p>{dateOfDiscovery}</p>
              </div>
              <div className="col-4">
                <h6>Name of Breach Reporter</h6>
                <p>{breachReporterName}</p>
              </div>
            </div>
            <div className="d-flex row report-details-2">
              <div className="col-4">
                <h6>Contact No of Breach Reporter</h6>
                <p>{reporterContactNo}</p>
              </div>
              <div className="col-4">
                <h6>Contact Email Breach Reporter</h6>
                <p>{reporterEmail}</p>
              </div>
              <div className="col-4">
                <h6>Name of Incident Owner</h6>
                <p>{incidentOwnerName}</p>
              </div>
            </div>
            <div className="d-flex row report-details-3">
              <div className="col-4">
                <h6>Contact No of Incident Owner</h6>
                <p>{incidentOwnerContactNo}</p>
              </div>
              <div className="col-4">
                <h6>Contact Email of Incident Owner</h6>
                <p>{incidentOwnerEmail}</p>
              </div>
              <div className="col-4">
                <h6>Type of Breach</h6>
                <p>{breachTypeText}</p>
              </div>
            </div>
            <div className="information-results row">
              <div className="col-12 details">
                <h6>Location Affected</h6>
                <p>{locationAffected}</p>
              </div>
              <div className="col-12 details">
                <h6>Brief Description of Breach</h6>
                <p>{descriptionOfBreach}</p>
              </div>
              <div className="col-12 details">
                <h6>Number of Affected Subjects - If Known</h6>
                <p>{affectedSubjects}</p>
              </div>
              <div className="col-12 details">
                <h6>Brief Description of Any Action Taken Since Discovery</h6>
                <p>{descriptionOfActionTakenSinceDiscovery}</p>
              </div>
            </div>
          </div>
          <div className="d-flex mt-3 ml-3 green-button justify-content-start ">
            <button
              className="d-flex justify-content-center styled-button "
              type="button"
              onClick={openNewForm}
            >
              Report Another Breach
            </button>
          </div>
        </div>
      </CustomScroll>
    </>
  );
};
